import React from "react";

import { FormattedMessage } from "react-intl";
// Bootstrap
import { Row, Col, Container, Navbar, Nav, NavDropdown } from "react-bootstrap";

// Styles
import "./index.scss";

const PageTitle = (props) => {
  const { fullName, onSignOutUser } = props;
  const onClickSignOut = () => {
    onSignOutUser();
  };
  return (
    <>
      <div className="page-title">
        <div className="container-fluid page-title-container p-0">
          <Row className="p-0 m-0 pt-3">
            <Col md={6}>
              <h2 className="mb-2">
                <FormattedMessage id={"page." + props.label + ".title"} />
              </h2>
            </Col>
            <Col md={6}>
              <Container>
                <Nav>
                  <NavDropdown
                    className="signoutStyle"
                    title={`Welcome ${fullName}`}
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item
                      className="signoutinner"
                      onClick={onClickSignOut}
                    >
                      Sign Out
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
              </Container>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default PageTitle;
